import { routeChecks } from '@/mixins/routeChecks'
import ContactApi from '@/misc/apis/ContactApi'
import ObjectApi from '@/misc/apis/ObjectApi'
import { CommonaddressAddress, Contactcontactv2Company, ObjectbuildingBuilding, ObjecttenancyTenancy, V2Person } from '@/types/api'
import { Contact } from '@/types/models'
import { contactForSendMail, getSendableEmail, getSendableEmailEntries, hasSendableEmail, isValidEmailFormat, recipientEmailForSend, type ContactWithEmailFields } from '@/misc/utils/contactEmail'

export type ContactWithSelectedContactPerson = Contact & {
  selectedContactPerson?: string | null
}

export { contactForSendMail, getSendableEmail, getSendableEmailEntries, hasSendableEmail, isValidEmailFormat, recipientEmailForSend }

const contact = {
  mixins: [routeChecks],
  data() {
    return {
      industriesList: [
        'INDUSTRY_LIVING_FURNISHING_HOUSEHOLD_APPLIANCES',
        'INDUSTRY_LIVING_FURNISHING_INTERIOR_DESIGN',
        'INDUSTRY_LIVING_FURNISHING_INTERIOR_DECORATION',
        'INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_TRADING',
        'INDUSTRY_LIVING_FURNISHING_REAL_ESTATE_MANAGEMENT',
        'INDUSTRY_LIVING_FURNISHING_CLEANING',
        'INDUSTRY_LIVING_FURNISHING_KEY_SERVICE',
        'INDUSTRY_LIVING_FURNISHING_BLINDS_AND_SHUTTERS',
        'INDUSTRY_LIVING_FURNISHING_MOVING',
        'INDUSTRY_LIVING_FURNISHING_CURTAINS',
        'INDUSTRY_LIVING_FURNISHING_OTHER',
        'INDUSTRY_BUILD_RENOVATE_ARCHITECTURE',
        'INDUSTRY_BUILD_RENOVATE_CONSTRUCTION',
        'INDUSTRY_BUILD_RENOVATE_ROOFING',
        'INDUSTRY_BUILD_RENOVATE_FLOORING_WALL_COVERINGS',
        'INDUSTRY_BUILD_RENOVATE_PLASTERER',
        'INDUSTRY_BUILD_RENOVATE_HEATING',
        'INDUSTRY_BUILD_RENOVATE_ENGINEERING',
        'INDUSTRY_BUILD_RENOVATE_PAINTER',
        'INDUSTRY_BUILD_RENOVATE_METAL_CONSTRUCTION',
        'INDUSTRY_BUILD_RENOVATE_SANITARY',
        'INDUSTRY_BUILD_RENOVATE_LOCKSMITH',
        'INDUSTRY_BUILD_RENOVATE_JOINERY',
        'INDUSTRY_BUILD_RENOVATE_PLUMBING',
        'INDUSTRY_BUILD_RENOVATE_CARPENTRY',
        'INDUSTRY_BUILD_RENOVATE_ELECTRICIAN',
        'INDUSTRY_BUILD_RENOVATE_OTHER',
        'INDUSTRY_BUILD_GLAZIER',
        'INDUSTRY_BUILD_SCAFFOLDER',
        'INDUSTRY_FINANCIAL_LAW_BANK',
        'INDUSTRY_FINANCIAL_LAW_ACCOUNTING',
        'INDUSTRY_FINANCIAL_LAW_FINANCIAL_CONSULTING',
        'INDUSTRY_FINANCIAL_LAW_NOTARY',
        'INDUSTRY_FINANCIAL_LAW_LAWYER',
        'INDUSTRY_FINANCIAL_LAW_TAX_CONSULTING',
        'INDUSTRY_FINANCIAL_LAW_ASSET_MANAGEMENT',
        'INDUSTRY_FINANCIAL_LAW_INSURANCE',
        'INDUSTRY_FINANCIAL_LAW_OTHER',
        'INDUSTRY_GARDEN_PLANTS_HORTICULTURE',
        'INDUSTRY_GARDEN_PLANTS_DUMPSTER_SERVICE',
        'INDUSTRY_GARDEN_PLANTS_OTHER',
        'INDUSTRY_OTHER_METER_READING',
        'INDUSTRY_OTHER_FACILITY_MANAGEMENT',
        'INDUSTRY_OTHER_MAINTENANCE_INSTALLATION',
        'INDUSTRY_OTHER_BUILDING_SERVICES_ENGINEERING',
        'INDUSTRY_OTHER_OTHER',
        'INDUSTRY_OTHER_FIRE_PROTECTION',
        'INDUSTRY_BUILD_RENOVATE_FACADES',
        'INDUSTRY_OTHER_WATERWORKS',
        'INDUSTRY_OTHER_SWEEPINGS',
        'INDUSTRY_OTHER_ANTENNA_SYSTEM',
        'INDUSTRY_OTHER_PEST_CONTROL',
        'INDUSTRY_FINANCIAL_LAW_PUBLIC_SECTOR',
        'INDUSTRY_BUILD_RENOVATE_AIR_CONDITIONING',
        'INDUSTRY_BUILD_RENOVATE_GARAGE_GATES',
        'INDUSTRY_BUILD_RENOVATE_MOLD_CONTROL',
        'INDUSTRY_OTHER_MARKINGS',
        'INDUSTRY_BUILD_RENOVATE_JOINTS',
        'INDUSTRY_OTHER_OIL',
        'INDUSTRY_BUILD_RENOVATE_LIFT_SERVICE',
        'INDUSTRY_OTHER_WATER_TREATMENT',
        'INDUSTRY_OTHER_ADVERTISING',
        'INDUSTRY_OTHER_CHIMNEY_SWEEPER',
        'INDUSTRY_OTHER_ENGRAVING',
        'INDUSTRY_BUILD_MASONRY',
        'INDUSTRY_CONSTRUCTION_MANAGEMENT',
        'INDUSTRY_SEWER_CLEANING',
        'INDUSTRY_NATURE_CONSERVATION',
        'INDUSTRY_GEOMATICS',
        'INDUSTRY_DECONSTRUCTION',
        'INDUSTRY_GEOLOGIST',
        'INDUSTRY_POLLUTANT_EXPERT',
        'INDUSTRY_INSULATION',
        'INDUSTRY_LOCKING_SYSTEMS'
      ],
      translatedRolesInBuilding: {
        craftsmen: 'BUILDING_CONTACT_TYPE_CRAFTSMAN',
        janitors: 'BUILDING_CONTACT_TYPE_JANITOR',
        serviceProvider: 'BUILDING_CONTACT_TYPE_SERVICE_PROVIDER',
        delegate: 'BUILDING_CONTACT_TYPE_DELEGATE',
        revisor: 'BUILDING_CONTACT_TYPE_REVISOR',
        tenantChange: 'BUILDING_CONTACT_TYPE_TENANT_CHANGE',
        owner: 'BUILDING_CONTACT_TYPE_OWNER'
      }
    }
  },
  methods: {
    getContactDetailRoute(contactId) {
      if (contactId !== null) {
        if (this.isOwnerModule) {
          return {
            name: 'OwnerContactDetailsView',
            params: { id: contactId }
          }
        } else if (this.isAdminModule) {
          return {
            name: 'AdminContactDetailsView',
            params: { id: contactId }
          }
        } else if (this.isMarketingModule) {
          return {
            name: 'MarketingContactDetailsView',
            params: { id: contactId }
          }
        } else if (this.isAssetModule) {
          return {
            name: 'AssetContactDetailsView',
            params: { id: contactId }
          }
        } else if (this.isAccountingModule) {
          return {
            name: 'AccountingContactDetailsView',
            params: { id: contactId }
          }
        }
      }
    },
    redirectToDetailPage(contactId) {
      if (contactId !== null) {
        if (this.isMarketingModule) {
          this.$router.push({
            name: 'MarketingContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isOwnerModule) {
          this.$router.push({
            name: 'OwnerContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAssetModule) {
          this.$router.push({
            name: 'AssetContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAdminModule) {
          this.$router.push({
            name: 'AdminContactDetailsView',
            params: { id: contactId }
          })
        } else if (this.isAccountingModule) {
          this.$router.push({
            name: 'AccountingContactDetailsView',
            params: { id: contactId }
          })
        }
      }
    },
    translatedIndustriesList(fullNames = true) {
      const array = []
      this.industriesList.forEach(industry => {
        let text = this.$t('message.contact.industries.' + industry)
        if (fullNames === false) {
          text = text.substr(text.indexOf(' - ') + 3)
        }

        array.push({
          label: text,
          value: industry
        })
      })
      array.sort((a, b) => {
        if (a.label.toLowerCase() < b.label.toLowerCase()) {
          return -1
        }
        if (a.label.toLowerCase() > b.label.toLowerCase()) {
          return 1
        }
        return 0
      })
      return array
    },
    getUrlWebsite(item) {
      if (item.indexOf('//') > -1) {
        return item
      } else {
        return '//' + item
      }
    },
    getPhoneNumbers(phoneNumbers, type, index = 0) {
      if (phoneNumbers && phoneNumbers.length > 0) {
        const matchingNumbers = phoneNumbers.filter(element =>
          element.type?.toLowerCase() === type?.toLowerCase()
        )
        if (matchingNumbers.length > index) {
          return matchingNumbers[index].number
        }
      }
      return '-'
    },
    getTranslatedIndustries(contact, fullNames = true) {
      if (!contact.industries ||
        contact.industries.length === 0 ||
        (contact.industries && contact.industries.length === 1 && contact.industries[0] === 'INDUSTRY_UNDEFINED_VALUE')) {
        return '-'
      } else {
        const array = []
        contact.industries.forEach((industry) => {
          if (industry !== 'INDUSTRY_UNDEFINED_VALUE') {
            if (fullNames) {
              array.push(this.$t('message.contact.industries.' + industry))
            } else {
              const text = this.$t('message.contact.industries.' + industry)
              array.push(text.substr(text.indexOf(' - ') + 3))
            }
          }
        })
        return array.join(', ')
      }
    },
    renderSalutationTooltip(contactType = 'private', salutation = '') {
      if (!salutation) salutation = contactType ? this.$t('message.contact.salutation.defaultSalutationIndividual') : this.$t('message.contact.salutation.defaultSalutationCompany')
      const prefix = this.$t('message.contact.salutation.salutationTooltip1')
      const postfix = this.$t('message.contact.salutation.salutationTooltip2')
      return prefix + salutation + postfix
    },
    renderSalutationPlaceholder(contactType = 'private', salutation = '', addExampleStringToPlaceholder) {
      if (!salutation) salutation = contactType ? this.$t('message.contact.salutation.defaultSalutationIndividual') : this.$t('message.contact.salutation.defaultSalutationCompany')
      let example = ''
      if (addExampleStringToPlaceholder) {
        example = this.$t('message.contact.salutation.example')
      }
      return example + salutation
    },
    initHeirsStateFromLoadedContact(contact) {
      const hasDateOfDeathFromObject = !!(contact.dateOfDeath?.year && contact.dateOfDeath?.month && contact.dateOfDeath?.day)
      const hasDateOfDeathFromString = !!(contact.dod && /^\d{4}-\d{2}-\d{2}$/.test(contact.dod))

      if (!hasDateOfDeathFromObject && !hasDateOfDeathFromString) {
        return
      }

      this.heirsAutoApplied = true
      const heirsSalutation = this.$t('message.contact.salutation.defaultSalutationHeirs')
      const salutationName = contact.salutationName ?? ''
      this.heirsOriginalSalutationName = salutationName === heirsSalutation ? '' : salutationName

      const gender = contact.gender ?? 'UNDEFINED_GENDER'
      this.heirsOriginalGender = gender === 'HEIRS' ? 'UNDEFINED_GENDER' : gender
    },
    revertHeirsOnDateOfDeathRemoved(contact) {
      const heirsSalutation = this.$t('message.contact.salutation.defaultSalutationHeirs')

      if (this.heirsAutoApplied) {
        contact.gender = this.heirsOriginalGender !== null ? this.heirsOriginalGender : 'UNDEFINED_GENDER'
        contact.salutationName = this.heirsOriginalSalutationName !== null ? this.heirsOriginalSalutationName : ''
        this.heirsOriginalGender = null
        this.heirsOriginalSalutationName = null
        this.heirsAutoApplied = false
        return
      }

      if (contact.gender === 'HEIRS' || contact.salutationName === heirsSalutation) {
        if (contact.gender === 'HEIRS') {
          contact.gender = 'UNDEFINED_GENDER'
        }
        if (contact.salutationName === heirsSalutation) {
          contact.salutationName = ''
        }
      }
    },
    getContactPhoneNumber(contact: Contactcontactv2Company | V2Person): string | null {
      if (!contact?.phoneNumbers) return null

      const mobile = contact.phoneNumbers.find(p => p.type === 'MOBILE')?.number
      if (mobile) return mobile

      const homes = contact.phoneNumbers.filter(p => p.type === 'HOME')
      if (homes.length > 0) return homes[0].number

      const work = contact.phoneNumbers.find(p => p.type === 'WORK')?.number
      if (work) return work

      if (homes.length > 1) return homes[1].number

      return null
    },
    getContactAddressBeforeTenancy(contact: Contactcontactv2Company | V2Person, tenancy: ObjecttenancyTenancy): CommonaddressAddress | null {
      if (!contact?.addressHistory) return null

      const sortedHistory = contact.addressHistory.sort((a, b) => {
        const dateA = new Date(a.validFrom.year, a.validFrom.month - 1, a.validFrom.day)
        const dateB = new Date(b.validFrom.year, b.validFrom.month - 1, b.validFrom.day)
        return dateB.getTime() - dateA.getTime()
      })

      const tenancyStartDate = new Date(tenancy.startingAt.year, tenancy.startingAt.month - 1, tenancy.startingAt.day)
      const priorAddress = sortedHistory.find(h => {
        const addressDate = new Date(h.validFrom.year, h.validFrom.month - 1, h.validFrom.day)
        return addressDate < tenancyStartDate
      })

      if (priorAddress) {
        return priorAddress.address
      }

      return null
    },
    getContactAddressAfterTenancy(contact: Contactcontactv2Company | V2Person, tenancy: ObjecttenancyTenancy): CommonaddressAddress | null {
      if (!contact?.addressHistory) return null

      const sortedHistory = contact.addressHistory.sort((a, b) => {
        const dateA = new Date(a.validFrom.year, a.validFrom.month - 1, a.validFrom.day)
        const dateB = new Date(b.validFrom.year, b.validFrom.month - 1, b.validFrom.day)
        return dateA.getTime() - dateB.getTime()
      })

      const tenancyEndDate = new Date(tenancy.endingAt.year, tenancy.endingAt.month - 1, tenancy.endingAt.day)
      const priorAddress = sortedHistory.find(h => {
        const addressDate = new Date(h.validFrom.year, h.validFrom.month - 1, h.validFrom.day)
        return tenancyEndDate < addressDate
      })

      if (priorAddress) {
        return priorAddress.address
      }

      return null
    },
    getSendableEmail(contact: ContactWithEmailFields | null | undefined): string | null {
      return getSendableEmail(contact)
    },
    hasSendableEmail(contact: ContactWithEmailFields | null | undefined): boolean {
      return hasSendableEmail(contact)
    },
    contactForSendMail<T extends ContactWithEmailFields>(contact: T | null | undefined): (T & { email: string }) | null {
      return contactForSendMail(contact)
    },
    getSendableEmailEntries<T extends ContactWithEmailFields>(contact: T | null | undefined): (T & { email: string })[] {
      return getSendableEmailEntries(contact)
    },
    recipientEmailForSend(recipient: ContactWithEmailFields | null | undefined): string | null {
      return recipientEmailForSend(recipient)
    },
    isValidEmailFormat(email: string | null | undefined): boolean {
      return isValidEmailFormat(email)
    },
    resolveContactByEmail(email: string): Contactcontactv2Company | V2Person | null {
      if (!email) return null

      const direct = this.contacts.find(c =>
        c.email === email || c.workEmail?.email === email
      )
      if (direct) return direct

      for (const c of this.contacts) {
        if (Array.isArray(c.contactPersons)) {
          const cp = c.contactPersons.find(cp =>
            cp.email === email || cp.workEmail?.email === email
          )
          if (cp) return cp
        }
      }

      return null
    },
    getNote(contact: Contact, buildingList: ObjectbuildingBuilding[]) {
      if (!contact.roleInBuilding) return null

      const contactRole = this.translatedRolesInBuilding[contact.roleInBuilding]
      for (const building of buildingList) {
        const buildingContact = building.contacts?.find(bContact => {
          if (bContact.type !== contactRole) return false
          if (bContact.id === contact.id) return true
          return !!contact.contactPersons?.some(p => p.id === bContact.id)
        })
        if (buildingContact && buildingContact.note !== '') {
          return buildingContact.note
        }
      }
      return null
    },
    contactPersonIdsEqual(left: string | null | undefined, right: string | null | undefined) {
      if (left == null || left === '' || right == null || right === '') {
        return left == null || left === '' ? (right == null || right === '') : false
      }
      return String(left) === String(right)
    },
    filterActiveContactPersons(contact: Contact) {
      if (!contact?.contactPersons?.length) {
        return []
      }
      return contact.contactPersons.filter(cp => cp.active !== false)
    },
    rowMatchesBuildingContact(row: Contact, buildingContact: { id?: string; type?: string }, contactRole: string) {
      if (!contactRole || buildingContact?.type !== contactRole) {
        return false
      }
      const companyId = row.id || (row as Contact & { objectID?: string }).objectID
      if (!companyId || !buildingContact?.id) {
        return false
      }
      if (this.contactPersonIdsEqual(buildingContact.id, companyId)) {
        return true
      }
      return !!row.contactPersons?.some(p => this.contactPersonIdsEqual(p.id, buildingContact.id))
    },
    findBuildingLinksForCompanyRow(row: Contact, buildingList: ObjectbuildingBuilding[]) {
      const contactRole = row.roleInBuilding ? this.translatedRolesInBuilding[row.roleInBuilding] : null
      const buildingContacts: { id: string; note?: string; type: string }[] = []
      const buildingIds: string[] = []
      const seenContactKeys = new Set<string>()

      if (!contactRole) {
        return { buildingContacts, buildingIds }
      }

      for (const building of buildingList || []) {
        const contacts = Array.isArray(building?.contacts) ? building.contacts : []
        for (const bc of contacts) {
          if (!bc?.id || !this.rowMatchesBuildingContact(row, bc, contactRole)) {
            continue
          }
          const key = `${building.id}:${bc.id}:${bc.type}`
          if (!seenContactKeys.has(key)) {
            seenContactKeys.add(key)
            buildingContacts.push(bc)
            if (building.id && !buildingIds.includes(building.id)) {
              buildingIds.push(building.id)
            }
          }
        }
      }
      return { buildingContacts, buildingIds }
    },
    getCompanyIdForContactRow(row: Contact) {
      return row.id || (row as Contact & { objectID?: string }).objectID || null
    },
    getTargetContactLinkId(row: Contact, selectedContactPerson: string | null | undefined) {
      if (selectedContactPerson) {
        return selectedContactPerson
      }
      return this.getCompanyIdForContactRow(row)
    },
    getLinkedPersonIdForCompanyRow(row: Contact, buildingList: ObjectbuildingBuilding[]) {
      const contactRole = row.roleInBuilding ? this.translatedRolesInBuilding[row.roleInBuilding] : null
      if (!contactRole) {
        return null
      }
      const companyId = this.getCompanyIdForContactRow(row)
      for (const building of buildingList || []) {
        const contacts = Array.isArray(building?.contacts) ? building.contacts : []
        for (const bc of contacts) {
          if (bc.type !== contactRole) {
            continue
          }
          if (row.contactPersons?.some(p => this.contactPersonIdsEqual(p.id, bc.id))) {
            return bc.id
          }
          if (this.contactPersonIdsEqual(bc.id, companyId)) {
            return null
          }
        }
      }
      return null
    },
    getCurrentBuildingContactLinkId(row: Contact, buildingList: ObjectbuildingBuilding[]) {
      const linkedPersonId = this.getLinkedPersonIdForCompanyRow(row, buildingList)
      if (linkedPersonId) {
        return linkedPersonId
      }
      const companyId = this.getCompanyIdForContactRow(row)
      const contactRole = row.roleInBuilding ? this.translatedRolesInBuilding[row.roleInBuilding] : null
      if (!companyId || !contactRole) {
        return null
      }
      for (const building of buildingList || []) {
        const contacts = Array.isArray(building?.contacts) ? building.contacts : []
        for (const bc of contacts) {
          if (bc.type === contactRole && this.contactPersonIdsEqual(bc.id, companyId)) {
            return companyId
          }
        }
      }
      return null
    },
    getInitialSelectedContactPersonId(contact: Contact, buildingList: ObjectbuildingBuilding[]) {
      const linkedPersonId = this.getLinkedPersonIdForCompanyRow(contact, buildingList)
      if (linkedPersonId) {
        return linkedPersonId
      }
      const companyId = this.getCompanyIdForContactRow(contact)
      const contactRole = contact.roleInBuilding ? this.translatedRolesInBuilding[contact.roleInBuilding] : null
      if (companyId && contactRole) {
        for (const building of buildingList || []) {
          const contacts = Array.isArray(building?.contacts) ? building.contacts : []
          for (const bc of contacts) {
            if (bc.type === contactRole && this.contactPersonIdsEqual(bc.id, companyId)) {
              return null
            }
          }
        }
      }
      const fromMap = this.getSelectedContactPerson
        ? this.getSelectedContactPerson(contact)
        : { id: null }
      return fromMap?.id || null
    },
    collectBuildingContactIds(buildingList: ObjectbuildingBuilding[]) {
      const contactIds: string[] = []
      for (const building of buildingList || []) {
        const contacts = Array.isArray(building?.contacts) ? building.contacts : []
        contacts.forEach(contact => {
          if (contact?.id) {
            contactIds.push(contact.id)
          }
        })
      }
      return [...new Set(contactIds)]
    },
    resolveContactsByIds(contactIds: string[]) {
      const filteredIds = [...new Set((contactIds || []).filter(id => id))]
      if (!filteredIds.length) {
        return Promise.resolve([] as Contact[])
      }
      return ContactApi.contactResolve(filteredIds).then(response => {
        return [...response.persons, ...response.companies] as Contact[]
      })
    },
    enrichCompanyRowForContactPersonColumn(row: Contact, buildingList: ObjectbuildingBuilding[]): ContactWithSelectedContactPerson {
      if (!row.contactPersons?.length) {
        return row
      }
      const temp: ContactWithSelectedContactPerson = Object.assign({}, row)
      temp.selectedContactPerson = this.getInitialSelectedContactPersonId(temp, buildingList)
      return temp
    },
    persistContactPersonChange(row: ContactWithSelectedContactPerson, buildingList: ObjectbuildingBuilding[]) {
      const contactRole = row.roleInBuilding ? this.translatedRolesInBuilding[row.roleInBuilding] : null
      const linkId = this.getTargetContactLinkId(row, row.selectedContactPerson)
      if (!contactRole || !linkId) {
        return Promise.resolve()
      }
      const { buildingContacts, buildingIds } = this.findBuildingLinksForCompanyRow(row, buildingList)
      if (!buildingIds.length) {
        return Promise.resolve()
      }
      const preservedNote = buildingContacts.find(bc => bc.note)?.note || this.getNote(row, buildingList) || ''
      return ObjectApi.removeBuildingContacts(buildingContacts, buildingIds).then(() =>
        ObjectApi.addBuildingContacts(
          [{ id: linkId, note: preservedNote, type: contactRole }],
          buildingIds
        )
      )
    }
  }
}

export { contact }
